import { render, staticRenderFns } from "./Gallery2.vue?vue&type=template&id=7a68685d&scoped=true"
import script from "./Gallery2.vue?vue&type=script&lang=js"
export * from "./Gallery2.vue?vue&type=script&lang=js"
import style0 from "./Gallery2.vue?vue&type=style&index=0&id=7a68685d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.94.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a68685d",
  null
  
)

export default component.exports